<template>
  <div class="leo2-news-detail">
    <div class="header">
      <span class="back" @click="goBack()"></span>
      资讯详情
    </div>

    <div class="content" v-if="detail">
      <h1 class="title">
        {{detail.Title}}
      </h1>
      <div class="time">
        {{detail.Date}}
      </div>
      <div class="description ck-content" v-html="detail.Content"></div>
    </div>
    <Ball></Ball>
  </div>
</template>

<script>
import '../../assets/css/ckeditor.css';
import Ball from "@/components/ball.vue";
import { storage } from "@/utils/storage.js";
export default {
  name: "detail",
  components: {
    Ball
  },
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.loadData()
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/news' })
    },
    loadData() {
      var id = this.$route.params.id;
      var key = 'news:' + id;
      this.axios.newsDetail({
        Id: id,
        is_count: !storage.get(key) ? 1 : 0
      }).then(res => {
        storage.set(key, 1);
        if (res.data.code === 0) {
          if (res.data.data) {
            this.detail = res.data.data

            document.title = res.data.data.Title + '-游好赚';
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.Discription);
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.Keywords);
          } else {
            this.detail = {}
          }
        } else {
          this.detail = {}
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .leo2-news-detail {
    padding-top: 44px;
    max-width: 750px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    padding-bottom: 96px;

    .header {
      position: fixed;
      width: 100%;
      overflow: hidden;
      top: 0;
      left: 0;
      right: 0;
      height: 44px;
      line-height: 44px;
      background-color: #333;
      color: white;
      text-align: center;
      z-index: 999;
      font-size: 18px;

      .back {
        position: absolute;
        left: 5px;
        top: 0;
        background: url("../../assets/imagesMobile/icon-back.png") no-repeat left center;
        background-size: 24px;
        padding-left: 25px;
        width: 30px;
        height: 100%;
        cursor: pointer;
      }
    }

    .content {
      margin: 15px;
      overflow: hidden;

      .title {
        font-size: 21px;
        line-height: 25px;
      }

      .time {
        line-height: 14px;
        font-size: 14px;
        color: #999;
        margin: 15px 0;
      }

      .description {
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-bottom: 15px;
        /deep/img{
          max-width: 100%;
        }
      }

      img {
        margin: 10px auto;
        width: 100%;
        height: auto;
      }
    }
  }
</style>
